export default function (alcaeus) {
    return (Base) => {
        return class extends Base {
            constructor(...rest) {
                super(...rest);
                Object.defineProperty(this, '_alcaeus', {
                    enumerable: false,
                    get() {
                        return alcaeus;
                    },
                });
            }
        };
    };
}
//# sourceMappingURL=ClientAccessor.js.map